<template>
    <div class="login-bg-main-section width-full float-l" id="login-main-hr">
        <div v-if="currentEnvironment" class="notification-block notification-block-top">
            <div role="alert" aria-live="polite" aria-atomic="true" class="alert alert-primary alert-dismissible">
                <div class="scroll-left">
                    <p>This is Test Environment !</p>
                </div>
            </div>
        </div>
        <div class="login-left-section float-l">
            <!--left section-->
            <router-link v-bind:to="{ path:'/'}"> <img src="/static/images/vvg-home-logo.png" alt="Velocity Truck Center"> </router-link>
        </div>
        <!--left section-->
        <div class="login-right-main-section width-full float-l">
            <!--right section-->
            <div class="login-r-left-section">
                <img src="/static/images/login-welcome-img.png" alt="Login Welcome Img">
                <p class="color-white heading-text-24 line-height-28 font-text-semi-medium-mont center mt-15 float-l"> Welcome to HR </p>
            </div>
            <div class="login-form-right-section">
                <div class="login-form float-l width-full">
                    <form id="loginUserForm">
                        <template v-if="ssoLogin">
                            <label class="checkbox-inline checkbox-bootstrap checkbox-lg">
                                    Logout from (<a v-bind:href="ssoUrl">{{ssoUrl}}</a>),If You are not able to login please clear Cookies and login again.
                                    Please contact admin if you are still not able to Login.
                                </label>
                        </template>
                        <template v-else>
                            <label v-if="isEmail == 'undefined'" for="uname" >Dayforce Id / Email<!--<span class="text-danger">*</span>--></label>
                            <label v-else-if="isEmail == true" for="uname" >Email<!--<span class="text-danger">*</span>--></label>
                            <label v-else for="uname" >Dayforce Id<!--<span class="text-danger">*</span>--></label>
                            <input id="username" type="text" placeholder="" name="uname" required v-model="loginFormData.username">
                            <font class="text-danger" v-html="frontendErrors.username"></font>

                            <label for="psw" class="loginLabel">Password<!--<span class="text-danger">*</span>--></label>
                            <input id="password" type="password" placeholder="" name="psw" required v-model="loginFormData.password">
                            <font class="text-danger" v-html="frontendErrors.password"></font>
                            <font class="text-danger"> <label  id="errorMsg" class="error text-danger" v-model="error"></label><br> </font>
                            <!-- <div class="remember-text-login float-l width-full">
                                <label class="loginLabel">
                                    <input type="checkbox" checked="checked" name="remember"> <label for="checkboxFiveInput"></label> Remember me
                                </label>
                            </div> -->
                            <div class="btm-login-section col-12">
                                <div class="row">
                                    <div class="btn-login-main float-l"> 
                                        <button type="submit" id="loginBtn" class="hvr-sweep-to-right-red" v-on:click.prevent="attemptLogin()">Login</button>
                                    </div>

                                    <div class="btn-login-main registre-btn float-l"> 
                                        <router-link v-bind:to="{ path:'/register'}"><button type="button" class="hvr-sweep-to-right-red"> Not Registered? Sign up</button></router-link>                                    
                                    </div>
                                </div>
                            </div>
                            <div class="forget-text float-l col-12 float-r">
                                <div class="row">
                                    <router-link v-bind:to="{name: 'ForgotPassword'}"> Forgot password?</router-link>
                                </div>
                            </div>
                            <!--<div class="btm-login-section col-12 float-l">
                                <div class="row">
                                    <div class="btn-login-main float-l col-6">
                                        <div class="row">
                                            <button type="submit" class="hvr-sweep-to-right-red" v-on:click.prevent="attemptLogin()">Login</button>
                                        </div>
                                    </div>

                                    <div class="forget-text float-l col-6 float-r">
                                        <div class="row">
                                            <router-link v-bind:to="{name: 'ForgotPassword'}"> Forgot password?</router-link>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="register-text-btm float-l width-full">
                                <p href="#"> Don't have an account yet? <router-link v-bind:to="{ path:'/register'}"> Register Now! </router-link> </p>
                            </div>-->
                        </template>
                    </form>
                </div>
            </div>
        </div>
        <!--right section-->
    </div>
</template>
<script>
    import EventBus from './event-bus';
    import {loginUrl, configs} from '../config';
    import SessioMixin from '../mixins/sessionmixin';
    import {HTTP} from '../http-common';
    import moment from 'moment';
    var self;
    import swal from 'sweetalert2/dist/sweetalert2.js';
    const Swal = require('sweetalert2');
    //import Autocomplete from 'vuejs-auto-complete'
    export default {
        name: 'Login',
        props: [''],
        components: {},
        mixins: [SessioMixin],
        data() {
            return {
                isEmail: "undefined",
                redirectUrl: '',
                loginFormData: {
                    username: '',
                    password: '',
                },
                errors: {},
                frontendErrors: {
                    username: '',
                    password: '',
                },
                error: '',
                ssoLogin:false,
                ssoUrl: '',
                projectSlug: ''
            }
        },
        beforeMount: function () {
            self = this;
            self.ssoLogin = true;
            self.ssoUrl = process.env.SSO_ROOT_URL;
            if(self.ssoLogin){
                const urlParams = new URLSearchParams(window.location.search);
                if (urlParams.has('token')) {
                    let token = urlParams.get('token');
                    localStorage.setItem("access_token",token);
                    let username = urlParams.get('username');

                    self.autoLoginUser(username)
                }else{
                    self.projectSlug = process.env.PROJECT_SLUG;
                    const redirectUrl = window.location.href;
                    
                    window.location.href = `${self.ssoUrl}/login?redirect=${encodeURIComponent(redirectUrl)}&slug=${self.projectSlug}`;
                }
            }else{
                var token = this.$route.query.token;
                token = (token === null || typeof (token) === "undefined" || token == '') ? '' : token;
                self.redirectUrl = this.$route.query.redirect_url;
                self.redirectUrl = (self.redirectUrl === null || typeof (self.redirectUrl) === "undefined" || self.redirectUrl == '') ? '' : self.redirectUrl;
                if (token != "") {
                    self.getUserFromToken(token, "login");
                }
                var userObj = localStorage.getItem("user_obj");
                if (userObj != null) {
                    var apiToken = localStorage.getItem("api_token");
                    apiToken = (apiToken === null || typeof (apiToken) === "undefined" || apiToken == '') ? '' : apiToken;
                    if (apiToken != '') {
                        if (self.redirectUrl != '') {
                            openDirectLink(self.redirectUrl);
                        } else {
                            openDirectLink('/');
                        }
                    }
                }
                /*if (token != '') {
                    //self.setCookie('vvg_sso_auth_token', token, 365);
                    window.localStorage.setItem("api_token", token);
                } else {
                    token = localStorage.getItem("api_token");
                }*/
            }
        },
        watch: {
            loginFormData: {
                handler(val){
                    if (self.loginFormData.username == '') {
                        self.isEmail = 'undefined';
                    } else {
                        self.isEmail = self.validEmail(self.loginFormData.username);
                    }
                },
                deep: true
            }
        },
        mounted: function () {
            /*self.loginFormData.username = self.getCookie('sales_username');
             self.loginFormData.password = self.getCookie('sales_password');*/
            //alert(localStorage.getItem("api_token"));

            $('#main-header').hide();
            $('#main-footer').hide();
            $('html,body,#app').css({
                //height: "100%"
            });
            $("#login-main-hr").height($(window).height());
            /*$("#login-main-hr").css({
             height:
             });*/

            $("#username").on('keyup', function () {
                self.frontendErrors.username = '';
            });
            $("#password").on('keyup', function () {
                self.frontendErrors.password = '';
            });
            /*console.log(this.checkLogin());*/
        },
        methods: {
            autoLoginUser: function (username) {
                var app = this;
                var config = {
                    headers: {Authorization: "Bearer " + localStorage.getItem("access_token")}
                };
                var fields = {
                    'username': username,
                    'access_token':window.localStorage.getItem('access_token')
                };
                HTTP.post("autologinuser", fields)
                    .then(function (data) {
                        if (data.status == 200) {
                            localStorage.setItem("api_token", data.data.content.access_token);
                            localStorage.setItem("access_token", data.data.content.access_token);
                            localStorage.setItem("user_obj", JSON.stringify(data.data.user_obj));
                            localStorage.setItem("expiry", moment(new Date()).add(6, 'h').toDate());
                            localStorage.setItem("profile_image", data.data.user_obj.profile_image);
                            localStorage.setItem("contact_detail_open", true);

                            window.location.href = "/";
                        }
                    })
                    .catch(function (err) {
                        if (err.response.status == 0) {
                            self.error = "Remote server can not be reachable";
                        } else {
                            //redirect to login page if user not authenticated
                            if (err.response.status == 401) {
                                //clear previous data
                                localStorage.removeItem("user_obj");
                                localStorage.removeItem("api_token");
                                localStorage.removeItem("profile_image");
                                self.$router.push("/login");
                            }
                            self.error = err.response.data.message;
                        }
                    })
            },
            validation: function () {
                var checked = true;
                self.frontendErrors.username = "";
                self.frontendErrors.password = "";
                if (!self.loginFormData.username) {
                    self.frontendErrors.username = "Dayforce Id Required.<br/>";
                    if (checked) {
                        checked = false;
                    }
                }
                if (!self.loginFormData.password) {
                    self.frontendErrors.password = "Password Required.<br/>";
                    if (checked) {
                        checked = false;
                    }
                }
                return checked;
            },
            attemptLogin() {
                $("#errorMsg").html('');
                self.validation();
                if (self.validation()) {
                    $('#loginBtn').html('Login...');
                    $('#loginBtn').prop('disabled', true);
                    HTTP.post("login", self.loginFormData)
                            .then(function (response) {
                                $('#loginBtn').html('Login');
                                $('#loginBtn').prop('disabled', false);
                                if (response.data.status == "success") {
                                    $('.navbar').show();
                                    //self.timezones = response.data.content;
                                    window.localStorage.setItem("expiry", moment(new Date()).add(6, 'h').toDate());
                                    window.localStorage.setItem("api_token", response.data.content.api_token);
                                    window.localStorage.setItem("user_obj", JSON.stringify(response.data.content.user_obj));
                                    window.localStorage.setItem("profile_image", response.data.content.user_obj.profile_image);
                                    window.localStorage.setItem("contact_detail_open", true);

                                    //self.setCookie('vvg_sso_auth_token', response.data.content.api_token, 365);
                                    /*self.setCookie('sales_username', self.loginFormData.username, 365);
                                     self.setCookie('sales_password', self.loginFormData.password, 365);*/

                                    EventBus.$emit('logged-in',
                                            true,
                                            response.data.content.user_obj["first_name"],
                                            response.data.content.user_obj["last_name"],
                                            response.data.content.user_obj["email"],
                                            response.data.content.user_obj["profile_image"]
                                            );
                                    /*self.$router.push("/");*/
                                    if (self.redirectUrl != '') {
                                        openDirectLink(self.redirectUrl);
                                    } else {
                                        openDirectLink('/');
                                    }
                                } else {
                                    $("#errorMsg").html(response.data.message);
                                    if (response.data.content.length > 0) {
                                        var err = "";
                                        err += response.data.content + "<br>";
                                        $("#errorMsg").html(err);
                                    }
                                }
                            })
                            .catch(function (err) {
                                $('#loginBtn').html('Login');
                                $('#loginBtn').prop('disabled', false);
                                self.Registerbtn = "Register";
                                if (err.response.status == 0) {
                                    self.error = "Remote server can not be reachable";
                                } else {
                                    $("#errorMsg").html(err.response.data.message);
                                    if (err.response.data.content.length > 0) {
                                        var err = "";
                                        err += err.response.data.content + "<br>";
                                        $("#errorMsg").html(err);
                                    }
                                }
                            });
                }
            }
        }

    }
</script>


// WEBPACK FOOTER //
// src/components/Login.vue